import {
  // Page,
  Text,
  View,
  Font,
} from '@react-pdf/renderer';

import HanSansCNLightFont from '../styles/fonts/HanSansCNLight.otf';
import { useSystemUtils } from '../../../../hooks/useSystemUtils';

import { styles } from '../styles/styles';

import { capitalizeString } from '../../../../utils/formatString';
import { adjustmentTypes } from '../../../../schema/documents/itemAdjustmentSchema';

Font.register({
  family: 'HanSansCNLightLight',
  src: HanSansCNLightFont,
});

const _styles = {
  fontChinese: {
    fontSize: 9,
    fontFamily: 'HanSansCNLightLight',
  },
};

export function BodyMainRowStyle1(props) {
  const { row, index } = props;

  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingVertical: 6,
        // backgroundColor: 'red',
        // paddingTop: 10,
        // paddingBottom: 3,
        // paddingBottom: 10,
        // paddingVertical: 10,
        // borderBottomColor: '#000',
        // borderBottomStyle: 'solid',
        // borderBottomWidth: 2,
      }}
    >
      <View style={{ width: '5%' }}>
        <Text style={[styles.h9, styles.weight]}>{index + 1}</Text>
      </View>
      <View style={{ width: '17%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.code}</Text>
      </View>
      <View style={{ width: '25%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.item_name}</Text>
      </View>
      <View style={{ width: '39%' }}>
        <Text style={[styles.h9, styles.weight, _styles.fontChinese]}>{row?.description}</Text>
      </View>
      <View style={{ width: '10%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.qty}</Text>
      </View>
      {/* {
                row.map((i, index) => {
                    return (
                        <View
                            key={index}
                            style={{
                                width: tableFields[index].width,
                                textAlign: tableFields[index]?.align? tableFields[index].align: ''
                            }}
                        >
                            <Text style={[styles.h9, { } ]}>{i}</Text>
                        </View>
                    )
                })
            } */}
    </View>
  );
}

export function BodyMainRowStyle2(props) {
  const { row, index } = props;

  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingVertical: 6,
        // backgroundColor: 'red',
        // paddingTop: 10,
        // paddingBottom: 3,
        // paddingBottom: 10,
        // paddingVertical: 10,
        // borderBottomColor: '#000',
        // borderBottomStyle: 'solid',
        // borderBottomWidth: 2,
      }}
    >
      <View style={{ width: '5%' }}>
        <Text style={[styles.h9, styles.weight]}>{index + 1}</Text>
      </View>
      <View style={{ width: '13%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.code}</Text>
      </View>
      <View style={{ width: '25%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.item_name}</Text>
      </View>
      <View style={{ width: '8%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.uom_name}</Text>
      </View>
      <View style={{ width: '8%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.qty}</Text>
      </View>
      <View style={{ width: '39%' }}>
        <Text style={[styles.h9, styles.weight, _styles.fontChinese]}>{row?.description}</Text>
      </View>
      {/* {
                row.map((i, index) => {
                    return (
                        <View
                            key={index}
                            style={{
                                width: tableFields[index].width,
                                textAlign: tableFields[index]?.align? tableFields[index].align: ''
                            }}
                        >
                            <Text style={[styles.h9, { } ]}>{i}</Text>
                        </View>
                    )
                })
            } */}
    </View>
  );
}

export function BodyMainRowStyle3(props) {
  const { formatCurrencyDisplay } = useSystemUtils();

  const { row, index } = props;

  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingVertical: 6,
        // backgroundColor: 'red',
        // paddingTop: 10,
        // paddingBottom: 3,
        // paddingBottom: 10,
        // paddingVertical: 10,
        // borderBottomColor: '#000',
        // borderBottomStyle: 'solid',
        // borderBottomWidth: 2,
      }}
    >
      <View style={{ width: '5%' }}>
        <Text style={[styles.h9, styles.weight]}>{index + 1}</Text>
      </View>
      <View style={{ width: '12%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.code}</Text>
      </View>
      <View style={{ width: '20%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.item_name}</Text>
      </View>
      <View style={{ width: '29%' }}>
        <Text style={[styles.h9, styles.weight, _styles.fontChinese]}>{row?.description}</Text>
      </View>
      <View style={{ width: '8%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.qty}</Text>
      </View>
      <View style={{ width: '11%' }}>
        <Text style={[styles.h9, styles.weight, styles.textAlignRight]}>{formatCurrencyDisplay(row?.uom_price)}</Text>
      </View>
      <View style={{ width: '11%' }}>
        <Text style={[styles.h9, styles.weight, styles.textAlignRight]}>{formatCurrencyDisplay(row?.sub_price)}</Text>
      </View>
    </View>
  );
}

// item receive
export function BodyMainRowStyle4(props) {
  const { formatCurrencyDisplay } = useSystemUtils();

  const { row, index } = props;

  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingVertical: 6,
      }}
    >
      <View style={{ width: '5%' }}>
        <Text style={[styles.h9, styles.weight]}>{index + 1}</Text>
      </View>
      <View style={{ width: '12%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.code}</Text>
      </View>
      <View style={{ width: '20%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.item_name}</Text>
      </View>
      <View style={{ width: '29%' }}>
        <Text style={[styles.h9, styles.weight, _styles.fontChinese]}>{row?.description}</Text>
      </View>
      <View style={{ width: '8%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.qty}</Text>
      </View>
      <View style={{ width: '10%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.uom_name}</Text>
      </View>
      <View style={{ width: '11%' }}>
        <Text style={[styles.h9, styles.weight, styles.textAlignRight]}>{row?.uom_price}</Text>
      </View>
    </View>
  );
}

// item transfer
export function BodyMainRowStyle5(props) {
  const { formatCurrencyDisplay } = useSystemUtils();

  const { row, index } = props;

  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingVertical: 6,
      }}
    >
      <View style={{ width: '5%' }}>
        <Text style={[styles.h9, styles.weight]}>{index + 1}</Text>
      </View>
      <View style={{ width: '12%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.code}</Text>
      </View>
      <View style={{ width: '20%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.item_name}</Text>
      </View>
      <View style={{ width: '31%' }}>
        <Text style={[styles.h9, styles.weight, _styles.fontChinese]}>{row?.description}</Text>
      </View>
      <View style={{ width: '8%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.qty}</Text>
      </View>
      <View style={{ width: '10%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.uom_name}</Text>
      </View>
      <View style={{ width: '10%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.verify_in_qty}</Text>
      </View>
      <View style={{ width: '7%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.verify_out_qty}</Text>
      </View>
      <View style={{ width: '11%' }}>
        <Text style={[styles.h9, styles.weight, styles.textAlignRight]}>
          {row?.scan_type === '1' ? 'Enabled' : 'Disabled'}
        </Text>
      </View>
    </View>
  );
}

// retail item receive
export function BodyMainRowStyle6(props) {
  const { formatCurrencyDisplay } = useSystemUtils();

  const { row, index } = props;

  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingVertical: 6,
      }}
    >
      <View style={{ width: '5%' }}>
        <Text style={[styles.h9, styles.weight]}>{index + 1}</Text>
      </View>
      <View style={{ width: '20%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.item_name}</Text>
      </View>
      <View style={{ width: '12%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.code}</Text>
      </View>
      <View style={{ width: '15%' }}>
        {/* <Text style={[styles.h9, styles.weight]}>{row?.qty}</Text> */}
        <Text style={[styles.h9, styles.weight]}>
          {row?.verify_in_qty} / {row?.qty} {row?.uom_name}
        </Text>
      </View>
      <View style={{ width: '6%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.unverify_in_qty}</Text>
      </View>
    </View>
  );
}

// delivery trip
export function BodyMainRowStyle7(props) {
  const { formatCurrencyDisplay } = useSystemUtils();

  const { row, index } = props;

  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        paddingVertical: 6,
      }}
    >
      <View style={{ width: '3%' }}>
        <Text style={[styles.h9, styles.weight]}>{index + 1}</Text>
      </View>
      <View style={{ width: '13%' }}>
        <Text style={[styles.h11, styles.weight]}>{row?.doc_number}</Text>
        <Text style={[styles.h9, styles.weight]}>{row?.doc_date}</Text>
      </View>
      {/* <View style={{ width: '16%' }}>
                <Text style={[styles.h9, styles.weight]}>{row?.doc_date}</Text>
            </View> */}
      <View style={{ width: '31%' }}>
        <Text style={[styles.h11, styles.weight]}>
          {row?.delivery_profile_name ? capitalizeString({ val: row.delivery_profile_name.toLowerCase() }) : '-'}
        </Text>

        <Text style={[styles.h9, styles.weight]}>
          {row?.delivery_address_1 ? capitalizeString({ val: row?.delivery_address_1.toLowerCase() }) : '-'}
        </Text>
        <Text style={[styles.h9, styles.weight]}>
          {row?.delivery_address_2 ? capitalizeString({ val: row?.delivery_address_2.toLowerCase() }) : '-'}
        </Text>
      </View>
      <View style={{ width: '9%' }}>
        <Text style={[styles.h9, styles.weight]}>
          {row?.delivery_area} {row?.delivery_state} {row?.delivery_country}
        </Text>
      </View>
      <View style={{ width: '11%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.is_collect_payment === '1' ? 'Enabled' : 'Disabled'}</Text>
      </View>
      <View style={{ width: '4%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.doc_ori_qty}</Text>
      </View>
      <View style={{ width: '12%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.is_complete_status === '1' ? 'Completed' : 'Pending'}</Text>
      </View>
    </View>
  );
}

// sales CN & DN
export function BodyMainRowStyle8(props) {
  const { formatCurrencyDisplay } = useSystemUtils();

  const { row, index } = props;

  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingVertical: 6,
      }}
    >
      <View style={{ width: '5%' }}>
        <Text style={[styles.h9, styles.weight]}>{index + 1}</Text>
      </View>
      <View style={{ width: '11%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.code}</Text>
      </View>
      <View style={{ width: '18%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.item_name}</Text>
      </View>
      <View style={{ width: '36%' }}>
        <Text style={[styles.h9, styles.weight, _styles.fontChinese]}>{row?.description}</Text>
      </View>
      <View style={{ width: '10%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.qty}</Text>
      </View>
      <View style={{ width: '11%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.uom_name}</Text>
      </View>
      <View style={{ width: '6%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.uom_price}</Text>
      </View>
    </View>
  );
}

// item relocate
export function BodyMainRowStyle9(props) {
  const { formatCurrencyDisplay } = useSystemUtils();

  const { row, index } = props;

  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingVertical: 6,
      }}
    >
      <View style={{ width: '5%' }}>
        <Text style={[styles.h9, styles.weight]}>{index + 1}</Text>
      </View>
      <View style={{ width: '11%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.code}</Text>
      </View>
      <View style={{ width: '32%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.item_name}</Text>
      </View>
      <View style={{ width: '9%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.qty}</Text>
      </View>
      <View style={{ width: '23%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.custom_batch_no}</Text>
      </View>
      <View style={{ width: '12%' }}>
        <Text style={[styles.h9, styles.weight]}>
          {row?.rack_name} / {row?.slot_name}
        </Text>
      </View>
      <View style={{ width: '10%' }}>
        <Text style={[styles.h9, styles.weight]}>
          {row?.relocate_rack_name} / {row?.relocate_slot_name}
        </Text>
      </View>
    </View>
  );
}

// transfer requisition
export function BodyMainRowStyle10(props) {
  const { formatCurrencyDisplay } = useSystemUtils();

  const { row, index } = props;

  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingVertical: 6,
      }}
    >
      <View style={{ width: '4%' }}>
        <Text style={[styles.h9, styles.weight]}>{index + 1}</Text>
      </View>
      <View style={{ width: '18%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.code}</Text>
      </View>
      <View style={{ width: '12%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.item_name}</Text>
      </View>
      <View style={{ width: '36%' }}>
        <Text style={[styles.h9, styles.weight, _styles.fontChinese]}>{row?.description}</Text>
      </View>
      <View style={{ width: '5%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.qty}</Text>
      </View>
      <View style={{ width: '7%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.uom_name}</Text>
      </View>
    </View>
  );
}

// item adjustment
export function BodyMainRowStyle11(props) {
  const { formatCurrencyDisplay } = useSystemUtils();

  const { row, index } = props;

  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingVertical: 6,
      }}
    >
      <View style={{ width: '5%' }}>
        <Text style={[styles.h9, styles.weight]}>{index + 1}</Text>
      </View>
      <View style={{ width: '12%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.code}</Text>
      </View>
      <View style={{ width: '20%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.item_name}</Text>
      </View>
      <View style={{ width: '31%' }}>
        <Text style={[styles.h9, styles.weight, _styles.fontChinese]}>{row?.description}</Text>
      </View>
      <View style={{ width: '8%' }}>
        <Text style={[styles.h9, styles.weight]}>
          {row?.adjustment_type === adjustmentTypes.increase.id ? '+' : '-'}
          {row?.qty}
        </Text>
      </View>
      <View style={{ width: '10%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.uom_name}</Text>
      </View>
      <View style={{ width: '10%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.verify_in_qty}</Text>
      </View>
      <View style={{ width: '7%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.verify_out_qty}</Text>
      </View>
    </View>
  );
}

// pick order
export function BodyMainRowStyle12(props) {
  const { formatCurrencyDisplay } = useSystemUtils();

  const { row, index } = props;

  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        paddingVertical: 6,
      }}
    >
      <View style={{ width: '3%' }}>
        <Text style={[styles.h9, styles.weight]}>{index + 1}</Text>
      </View>
      <View style={{ width: '13%' }}>
        <Text style={[styles.h11, styles.weight]}>{row?.doc_number}</Text>
        <Text style={[styles.h9, styles.weight]}>{row?.doc_date}</Text>
      </View>
      {/* <View style={{ width: '16%' }}>
                <Text style={[styles.h9, styles.weight]}>{row?.doc_date}</Text>
            </View> */}
      <View style={{ width: '31%' }}>
        <Text style={[styles.h11, styles.weight]}>
          {row?.delivery_profile_name ? capitalizeString({ val: row.delivery_profile_name.toLowerCase() }) : '-'}
        </Text>

        <Text style={[styles.h9, styles.weight]}>
          {row?.delivery_address_1 ? capitalizeString({ val: row?.delivery_address_1.toLowerCase() }) : '-'}
        </Text>
        <Text style={[styles.h9, styles.weight]}>
          {row?.delivery_address_2 ? capitalizeString({ val: row?.delivery_address_2.toLowerCase() }) : '-'}
        </Text>
      </View>
      <View style={{ width: '9%' }}>
        <Text style={[styles.h9, styles.weight]}>
          {row?.delivery_area} {row?.delivery_state} {row?.delivery_country}
        </Text>
      </View>
      <View style={{ width: '4%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.doc_ori_qty}</Text>
      </View>
    </View>
  );
}

// pick order item by document view
export function BodyMainRowStyle13(props) {
  const { formatCurrencyDisplay } = useSystemUtils();

  const { row, index, document } = props;
  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        paddingVertical: 6,
      }}
    >
      <View style={{ width: '3%' }}>
        <Text style={[styles.h9, styles.weight]}>{index + 1}</Text>
      </View>

      <View style={{ width: '13%' }}>
        <Text style={[styles.h11, styles.weight]}>{row?.doc_doc_no}</Text>
        <Text style={[styles.h9, styles.weight]}>{row?.doc_doc_date}</Text>
      </View>

      <View style={{ width: '31%' }}>
        <Text style={[styles.h11, styles.weight]}>
          {document?.delivery_profile_name
            ? capitalizeString({ val: document.delivery_profile_name.toLowerCase() })
            : '-'}
        </Text>

        <Text style={[styles.h9, styles.weight]}>
          {document?.delivery_address_1 ? capitalizeString({ val: document?.delivery_address_1.toLowerCase() }) : '-'}
        </Text>
        <Text style={[styles.h9, styles.weight]}>
          {document?.delivery_address_2 ? capitalizeString({ val: document?.delivery_address_2.toLowerCase() }) : '-'}
        </Text>
      </View>

      <View style={{ width: '13%' }}>
        <Text style={[styles.h11, styles.weight]}>{row?.code}</Text>
      </View>

      <View style={{ width: '13%' }}>
        <Text style={[styles.h11, styles.weight]}>{row?.item_name}</Text>
      </View>

      <View style={{ width: '4%' }}>
        <Text style={[styles.h9, styles.weight]}>{row?.doc_ori_qty}</Text>
      </View>
    </View>
  );
}

// pick order item by location view
export function BodyMainRowStyle14(props) {
  const { formatCurrencyDisplay } = useSystemUtils();
  const { row, index } = props;
  const availableSlots = row?.available_slot_uids;
  console.log(row);
  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        paddingVertical: 6,
      }}
    >
      <View style={{ width: '3%' }}>
        <Text style={[styles.h9, styles.weight]}>{index + 1}</Text>
      </View>

      <View style={{ width: '13%' }}>
        <Text style={[styles.h11, styles.weight]}>{row?.code}</Text>
      </View>

      <View style={{ width: '13%' }}>
        <Text style={[styles.h11, styles.weight]}>{row?.item_name}</Text>
      </View>

      <View style={{ width: '13%' }}>
        <Text style={[styles.h9, styles.weight]}>{`${row?.require_qty} ${row?.uom_name}`}</Text>
      </View>

      <View style={{ width: '30%' }}>
        {availableSlots.map((i, index) => {
          return <Text style={[styles.h9, styles.weight]}>{i?.rack_slot_lbl}</Text>;
        })}
      </View>

      <View style={{ width: '10%' }}>
        {availableSlots.map((i, index) => {
          return <Text style={[styles.h9, styles.weight]}>{`${i?.qty_remain} ${row?.uom_name}`}</Text>;
        })}
      </View>
    </View>
  );
}
